<template>

	<div>
		<div class="head">
			<div class="head_img">
				<img src="../assets/boloni.jpg" />
				<ul>
					<li><a href="#" @click="ten()">相关资料</a></li>
					<li><a href="#" @click="nine()">主要原材料及配套厂家资料</a></li>
					<li><a href="#" @click="eight()">检测工具及设备</a></li>
					<li><a href="#" @click="seven()">主要生产设备</a></li>
					<li><a href="#" @click="twelve()">竞品客户信息</a></li>
					<li><a href="#" @click="six()">销售前五名客户</a></li>
					<li><a href="#" @click="five()">付款信息</a></li>
					<li><a href="#" @click="four()">人员信息</a></li>
					<li><a href="#" @click="eleven()">供货产品及产能</a></li>
					<li><a href="#" @click="three()">经营情况</a></li>
					<li><a href="#" @click="two()">基本信息</a></li>
					<li><a href="#" @click="one()">供货类型</a></li>
				</ul>
			</div>
		</div>

		<div class="main">
			<div class="main_title">
				<span>主要原材料及配套厂家资料</span>
			</div>
			<div class="item">
				<span class="item_title">请完善以下信息</span>
			</div>
			<div class="main_info">
				<div class="payment_info el-table">
					<el-table :data="MateLineFrom" border>
						<el-table-column label="主要原材料" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.material_main"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="供应厂家" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.material_fac"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="供应厂家所在城市" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.material_brand"></el-input>
								<!-- <el-select v-model="scope.row.material_brand" filterable placeholder="请选择">
									<el-option
										v-for="item in options"
										:key="item.value"
										:label="item.label"
										:value="item.value">
									</el-option>
								</el-select> -->
							</template>
						</el-table-column>
						<el-table-column label="采购周期" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.material_cycle"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="备注" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.remark"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="keyId" v-if="false">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.keyid"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<el-button @click="handleDelete(scope.$index,scope.row.keyid)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>

				</div>
				<div class="payment_info_button">
					<button type="button" @click="addLine"><span>新增行</span></button>
					<button type="button" @click="openTest()"><span>上一步</span></button>
					<button type="button" style="background-color: #27eaff"
						@click="addMateLine()"><span>保存</span></button>
					<button type="button" @click="nextMate()"><span>下一步</span></button>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		getGys,
		addMateLine,
		delMateLine,
		getBaseCity,
		getMateLine
	} from '../api/LoginApi'
	import {
		goBack
	} from '../utils/Transformation'
	import {
		messageError,
		messageSuCcEss
	} from '../utils/message'

	export default {
		name: 'GysMateLine',
		data() {
			return {
				MateLineFrom: [{
					gys_no: localStorage.getItem('userName'),
					material_main: '',
					material_fac: '',
					material_brand: '',
					material_cycle: '',
					remark: '',
					keyid: 0,
					show: true
				}],
				options: [],
				value: ''
			}
		},
		created() {
			this.getMateLine()
		},
		mounted() {
			// 页面刷新时清除localStorage
			window.onbeforeunload = function(e) {
				let storage = window.localStorage
				storage.clear()
			}
			// localStorage不存在loginguid则跳到登录页面
			if (!localStorage.getItem('loginguid')) {
				const vm = this
				vm.$router.push({
					path: '/Login'
				})
			}
			// 不允许使用页面返回按钮
			if (window.history && window.history.pushState) {
				// 向历史记录中插入了当前页
				history.pushState(null, null, document.URL)
				window.addEventListener('popstate', goBack, false)
			}

			//查询城市
			// this.getCity();
		},
		destroyed() {
			window.removeEventListener('popstate', goBack, false)
		},
		methods: {
			 // 给表头加必填符号*
			addRedStar(h, { column }) {
				return [
					h("span", { style: "color: red" }, "*"),
					h("span", " " + column.label),
				];
			},
			// 查询数据
			getMateLine() {
				getMateLine(localStorage.getItem('userName')).then(res => {
					if (res.length > 0) {
						this.MateLineFrom = res
						// console.log('主要原材料及配套厂家资料', res)
					}
					//获取单据状态
					getGys(localStorage.getItem('userName')).then(res => {
						if (res) {
							this.MateLineFrom.bill_status = res.bill_status;
						}
					});
				})
			},
			// 上一个页面
			openTest() {
				const vm = this
				vm.$router.push({
					path: '/GysTestLine'
				})
			},
			// 下一个页面
			nextMate() {
				if (this.MateLineFrom.bill_status != '已审核') { 
					//保存数据
					this.addMateLine();
					const vm = this;

					if(this.MateLineFrom.length > 0){
						for(var i = 0; i < this.MateLineFrom.length; i++){
							var item = this.MateLineFrom[i];
							// if (item.material_main){
								if (!item.material_main){
									return messageError('第'+(i+1)+'行[主要原材料]不能为空!');
								}
								if (!item.material_fac){
									return messageError('第'+(i+1)+'行[供应厂家]不能为空!');
								}
								if (!item.material_brand){
									return messageError('第'+(i+1)+'行[品牌]不能为空!');
								}
								if (!item.material_cycle){
									return messageError('第'+(i+1)+'行[采购周期]不能为空!');
								}
								if (!item.remark){
									return messageError('第'+(i+1)+'行[备注]不能为空!');
								}
							// }
						}
					}
				}
				const vm = this;
				// material_main: '',
				// 	material_fac: '',
				// 	material_brand: '',
				// 	material_cycle: '',
				// 	remark: '',
				vm.$router.push({
					path: '/GysMate'
				})
			},
			one() {
				const vm = this
				vm.$router.push({
					path: '/GysBasic'
				})
			},
			two() {
				const vm = this
				vm.$router.push({
					path: '/Bas_info'
				})
			},
			three() {
				const vm = this
				vm.$router.push({
					path: '/Operation'
				})
			},
			four() {
				const vm = this
				vm.$router.push({
					path: '/Personnel_info'
				})
			},
			five() {
				const vm = this
				vm.$router.push({
					path: '/Payment_info'
				})
			},
			six() {
				const vm = this
				vm.$router.push({
					path: '/GysCooPeRate'
				})
			},
			seven() {
				const vm = this
				vm.$router.push({
					path: '/GysMainLine'
				})
			},
			eight() {
				const vm = this
				vm.$router.push({
					path: '/GysTestLine'
				})
			},
			nine() {
				const vm = this
				vm.$router.push({
					path: '/GysMateLine'
				})
			},
			ten() {
				const vm = this
				vm.$router.push({
					path: '/GysMate'
				})
			},
			eleven() {
				const vm = this
				vm.$router.push({
					path: '/ProductsCapacity '
				})
			},
			// 保存数据
			addMateLine: function() {
				if (this.MateLineFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}

				if(this.MateLineFrom.length > 0){
						for(var i = 0; i < this.MateLineFrom.length; i++){
							var item = this.MateLineFrom[i];
							// if (item.material_main){
								if (!item.material_main){
									return messageError('第'+(i+1)+'行[主要原材料]不能为空!');
								}
								if (!item.material_fac){
									return messageError('第'+(i+1)+'行[供应厂家]不能为空!');
								}
								if (!item.material_brand){
									return messageError('第'+(i+1)+'行[品牌]不能为空!');
								}
								if (!item.material_cycle){
									return messageError('第'+(i+1)+'行[采购周期]不能为空!');
								}
								if (!item.remark){
									return messageError('第'+(i+1)+'行[备注]不能为空!');
								}
							// }
						}
				}

				addMateLine(this.MateLineFrom, localStorage.getItem('userName')).then(res => {
					if (res.code === 200) {
						return messageSuCcEss(res.msg)
					} else {
						return messageError(res.msg)
					}
				})
			},
			// 删除行，删除数据
			handleDelete: function(index, keyId) { // 删除行数
				if (this.MateLineFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}
				if (keyId) {
					delMateLine(keyId).then(res => {
						if (res.code === 200) {
							return messageSuCcEss(res.msg)
						} else {
							return messageError(res.msg)
						}
					})
				}
				this.MateLineFrom.splice(index, 1)
			},
			// 新增行
			addLine: function() {
				if (this.MateLineFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}
				let RateValue = {
					gys_no: localStorage.getItem('userName'),
					material_main: '',
					material_fac: '',
					material_brand: '',
					material_cycle: '',
					remark: '',
					keyid: 0,
					show: true
				}
				this.MateLineFrom.push(RateValue)
			},

			getCity: function() {
				// if (query !== '') {
					this.loading = true;
					// setTimeout(() => {
					// 	this.loading = false;
					// 	this.options = this.list.filter(item => {
					// 	return item.label.toLowerCase()
					// 		.indexOf(query.toLowerCase()) > -1;
					// 	});
					// }, 200);
					// console.log("getBaseCity");
					getBaseCity('').then(res => {
						this.loading = false;
						console.log("getBaseCity result: ", res);
						// 清空城市列表数据
						this.options.splice(0, this.options.length);
						res.forEach(item => {
							this.options.push({
								value: item.city_name,
								label: item.city_name
							})
						})
						console.log("getBaseCity options: ", this.options);
					})
				// } 
				// else {
				// 	this.options = [];
				// }
			}
		}
	}
</script>


<style scoped>
	@import "../css/Main.css";
</style>



// WEBPACK FOOTER //
// src/componentsline/GysMateLine.vue